import { render, staticRenderFns } from "./MentoTeamCard.vue?vue&type=template&id=85290cc2&scoped=true&"
import script from "./MentoTeamCard.vue?vue&type=script&lang=js&"
export * from "./MentoTeamCard.vue?vue&type=script&lang=js&"
import style0 from "./MentoTeamCard.vue?vue&type=style&index=0&id=85290cc2&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "85290cc2",
  null
  
)

export default component.exports